interface SignupRequestError {
  config?: { url?: string; method?: string };
  response?: { status?: number; data?: { code?: string; message?: unknown } };
}

const backgroundReads = new Set([
  '/api/pipeline/list', '/api/reviews', '/api/get-all-reviews',
  '/api/get-total-review-count-and-rating', '/api/payments/has-stripe-account',
  '/api/monthly-request-count', '/api/employee-leaderboard',
]);

/** Expected setup limitations are already explained by the dashboard status bar.
 * Keep rejecting the request so callers never mistake a denied action for success.
 * Genuine permission failures, outages and failed payments retain normal errors.
 */
export function signupRequestFeedback(error: SignupRequestError): 'silent' | 'notice' | null {
  const { status, data } = error?.response || {};
  if (status !== 403 || !['SIGNUP_ACTIVATION_REQUIRED', 'SIGNUP_TEXTING_NOT_READY'].includes(data?.code || '')) return null;
  const method = String(error.config?.method || 'GET').toUpperCase();
  if (method === 'GET' || method === 'HEAD') return 'silent';
  let path = '';
  try { path = new URL(error.config?.url || '', 'https://dashboard.example').pathname.replace(/\/+$/, ''); } catch { /* Treat unknown mutations as deliberate actions. */ }
  if (method === 'POST' && backgroundReads.has(path)) return 'silent';
  return 'notice';
}
